import ROUTE_NAMES from '@/app/admin/router/router-const';

export default [
  {
    path: 'crm',
    name: ROUTE_NAMES.LOGIN_CRM,
    component: () => import('../CRMLoginPage.vue'),
  }
];